import { findRecursive } from '@/mm/utils.js'

export function washData_expandCollapseTags(walkedNode) {
  if (walkedNode._type === 'expandCollapse_tags_style5') {
    const ProNode = findRecursive(walkedNode.list, (item) => item._type === 'button_text_7', 'list')
    const ProTitleNode = findRecursive(
      walkedNode.list,
      (item) => item.componentName === 'text_title',
      'list'
    )
    if (ProNode) {
      if (!ProNode.actions[0].config['文字设计'].find((item) => item === 'self_textInput')) {
        ProNode.actions[0].config['文字设计'].unshift('self_textInput')
      } else if (!ProNode.actions.find((item) => item === 'translate')) {
        ProNode.actions.push('translate')
      }
    }
    if (ProTitleNode) {
      if (!ProTitleNode.actions.find((item) => item === 'translate')) {
        ProTitleNode.actions.push('translate')
      } else if (!ProTitleNode.actions.find((item) => item === 'edit')) {
        ProTitleNode.actions.unshift('edit')
      }
    }
  } else if (walkedNode._type === 'expandCollapse_tags_style4') {
    const ProNode = findRecursive(walkedNode.list, (item) => item._type === 'button_text_7', 'list')
    const ProTitleNode = findRecursive(
      walkedNode.list,
      (item) => item.componentName === 'text_title',
      'list'
    )
    if (ProNode) {
      if (!ProNode.actions[0].config['文字设计'].find((item) => item === 'self_textInput')) {
        ProNode.actions[0].config['文字设计'].unshift('self_textInput')
      } else if (!ProNode.actions.find((item) => item === 'translate')) {
        ProNode.actions.push('translate')
      }
    }
    if (ProTitleNode) {
      if (!ProTitleNode.actions.find((item) => item === 'translate')) {
        ProTitleNode.actions.push('translate')
      } else if (!ProTitleNode.actions.find((item) => item === 'edit')) {
        ProTitleNode.actions.unshift('edit')
      } else if (
        !ProTitleNode.actions[1].config['设置'].find((item) => item === 'self_background')
      ) {
        ProTitleNode.actions[1].config['设置'].unshift('self_background')
      }
    }
  } else if (walkedNode._type === 'expandCollapse_tags_style1') {
    const ProNode = findRecursive(walkedNode.list, (item) => item._type === 'button_text_7', 'list')
    const ProTitleNode = findRecursive(
      walkedNode.list,
      (item) => item.componentName === 'text_title',
      'list'
    )
    if (ProNode) {
      if (!ProNode.actions[0].config['文字设计'].find((item) => item === 'self_textInput')) {
        ProNode.actions[0].config['文字设计'].unshift('self_textInput')
      } else if (!ProNode.actions.find((item) => item === 'translate')) {
        ProNode.actions.push('translate')
      }
    }
    if (ProTitleNode) {
      if (!ProTitleNode.actions.find((item) => item === 'translate')) {
        ProTitleNode.actions.push('translate')
      } else if (!ProTitleNode.actions.find((item) => item === 'edit')) {
        ProTitleNode.actions.unshift('edit')
      } else if (
        !ProTitleNode.actions[1].config['设置'].find((item) => item === 'self_background')
      ) {
        ProTitleNode.actions[1].config['设置'].unshift('self_background')
      }
    }
  } else if (walkedNode._type === 'expandCollapse_tags_style2') {
    const ProNode = findRecursive(walkedNode.list, (item) => item._type === 'button_text_7', 'list')
    const ProTitleNode = findRecursive(
      walkedNode.list,
      (item) => item.componentName === 'text_title',
      'list'
    )
    if (ProNode) {
      if (!ProNode.actions[0].config['文字设计'].find((item) => item === 'self_textInput')) {
        ProNode.actions[0].config['文字设计'].unshift('self_textInput')
      } else if (!ProNode.actions.find((item) => item === 'translate')) {
        ProNode.actions.push('translate')
      }
    }
    if (ProTitleNode) {
      if (!ProTitleNode.actions.find((item) => item === 'translate')) {
        ProTitleNode.actions.push('translate')
      } else if (!ProTitleNode.actions.find((item) => item === 'edit')) {
        ProTitleNode.actions.unshift('edit')
      } else if (
        !ProTitleNode.actions[1].config['设置'].find((item) => item === 'self_background')
      ) {
        ProTitleNode.actions[1].config['设置'].unshift('self_background')
      }
    }
  } else if (walkedNode._type === 'expandCollapse_tags_style6') {
    const ProNode = findRecursive(walkedNode.list, (item) => item._type === 'button_text_7', 'list')
    const ProTitleNode = findRecursive(
      walkedNode.list,
      (item) => item.componentName === 'text_title',
      'list'
    )
    if (ProNode) {
      if (!ProNode.actions[0].config['文字设计'].find((item) => item === 'self_textInput')) {
        ProNode.actions[0].config['文字设计'].unshift('self_textInput')
      } else if (!ProNode.actions.find((item) => item === 'translate')) {
        ProNode.actions.push('translate')
      }
    }
    if (ProTitleNode) {
      if (!ProTitleNode.actions.find((item) => item === 'translate')) {
        ProTitleNode.actions.push('translate')
      } else if (!ProTitleNode.actions.find((item) => item === 'edit')) {
        ProTitleNode.actions.unshift('edit')
      } else if (
        !ProTitleNode.actions[1].config['设置'].find((item) => item === 'self_background')
      ) {
        ProTitleNode.actions[1].config['设置'].unshift('self_background')
      }
    }
  }
}
